<p-accordion class="accordion-wrapper">
  <p-accordionTab [header]="label" [selected]="true">
    <div class="p-grid form-row">
      <div class="p-col-2">
        <button pButton type="button" class="p-button-info" label="Add" (click)="addRule()"></button>
      </div>
      <div class="p-col-8"></div>
    </div>
    <div [formGroup]="ruleForm" autoTrackUnsavedChanges>
      <div [formArrayName]="controlName">
        <div *ngIf="rules.length === 0" class="p-text-center p-mt-2">
          <p><i>No rules created yet</i></p>
        </div>
        <div *ngIf="rules.length > 0">
          <div class="p-grid p-justify-center form-row">
            <div class="p-col-2 fixed-width-dropdown"><strong>Property Value</strong></div>
            <div class="p-col-2 fixed-width-dropdown"><strong>Operator</strong></div>
            <div class="p-col-2 fixed-width-dropdown"><strong>Value</strong></div>
            <div class="p-col-1"></div>
          </div>
          <div class="p-grid p-justify-center form-row" *ngFor="let rule of rules.controls; let idx = index"
               [formGroupName]="idx">
            <div class="p-col-2 fixed-width-dropdown">
              <p-dropdown [options]="propertyValueFilters" formControlName="propertyValue"
                          (onChange)="clearValues(rule)"
                          placeholder="Select Property"
                          [appendTo]="'body'"></p-dropdown>
            </div>
            <div class="p-col-2 fixed-width-dropdown">
              <p-dropdown
                *ngIf="!isFilterSelected(rule, 'Make') && !isFilterSelected(rule, 'New/Used')"
                [options]="getOperatorOptions(rule.get('propertyValue').value)"
                formControlName="selectedOperator"
                placeholder="Select Operator"
                [appendTo]="'body'">
              </p-dropdown>
              <i *ngIf="isFilterSelected(rule, 'Make') || isFilterSelected(rule, 'New/Used')">Automatically selected</i>
            </div>
            <div class="p-col-2 fixed-width-dropdown">
              <div *ngIf="!isFilterSelected(rule, 'New/Used') && !isFilterSelected(rule, 'Make') && !isAccountIdFilterSelected(rule)">
                <input pInputText formControlName="value" placeholder="Enter Value"/>
              </div>
              <div *ngIf="isFilterSelected(rule, 'New/Used')">
                <div class="new-used-field">
                  <div class="new-used-input-field">
                    <p-radioButton
                      name="value"
                      value="New"
                      formControlName="value"
                      inputId="new"
                      (onClick)="setNewUsedOperator(rule)"
                    ></p-radioButton>
                    <label for="new">New</label>
                  </div>
                  <div class="new-used-input-field">
                    <p-radioButton
                      name="value"
                      value="Used"
                      formControlName="value"
                      inputId="used"
                      (onClick)="setNewUsedOperator(rule)"
                    ></p-radioButton>
                    <label for="used">Used</label>
                  </div>
                </div>
              </div>
              <div *ngIf="isFilterSelected(rule, 'Make')">
                  <p-multiSelect [options]="makes" formControlName="value" optionLabel="displayName" optionValue="id" placeholder="Select Makes" (onChange)="handleValueDropdownChange(rule)" [appendTo]="'body'"></p-multiSelect>
              </div>
              <div *ngIf="isAccountIdFilterSelected(rule)">
                  <p-multiSelect
                    formControlName="value"
                    placeholder="Select Accounts"
                    [options]="sourceAccountOptions"
                    [filter]="true"
                    filterBy="label,value"
                    [filterFields]="['label','value']"
                    [resetFilterOnHide]="true">
                  </p-multiSelect>
              </div>
            </div>
            <div class="p-col-1">
              <button pButton type="button" class="p-button-danger p-button-icon" (click)="deleteRule(idx)">
                <i class="pi pi-trash"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </p-accordionTab>
</p-accordion>
